var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-container"},[_c('the-header',{ref:"theHeader"}),_c('main',{staticClass:"dashboard-content"},[_c('iframe',{staticClass:"viz-frame",attrs:{"src":_vm.url,"title":"EMR Dashboard"}})]),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }